/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAlumniProfile = /* GraphQL */ `
  query GetAlumniProfile($id: ID!) {
    getAlumniProfile(id: $id) {
      id
      firstName
      firstNameDisplay
      lastName
      lastNameDisplay
      about
      isOpenToWork
      isWillingToTravel
      publicProfile
      skills
      owner
      linkedInUrl
      countryCode
      stateCode
      cityName
      branch
      cohortID
      email
      isMilitarySpouse
      profilePictureKey
      occupation
      headline
      experiences {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        company
        title
        description
        location
        logoUrl
      }
      educations {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        fieldOfStudy
        degreeName
        school
        description
        logoUrl
      }
      certifications {
        startsAt {
          day
          month
          year
        }
        endsAt {
          day
          month
          year
        }
        url
        name
        licenseNumber
        displaySource
        authority
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAlumniProfiles = /* GraphQL */ `
  query ListAlumniProfiles(
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlumniProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        occupation
        headline
        experiences {
          company
          title
          description
          location
          logoUrl
        }
        educations {
          fieldOfStudy
          degreeName
          school
          description
          logoUrl
        }
        certifications {
          url
          name
          licenseNumber
          displaySource
          authority
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const alumniProfilesByOwner = /* GraphQL */ `
  query AlumniProfilesByOwner(
    $owner: String
    $sortDirection: ModelSortDirection
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alumniProfilesByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        occupation
        headline
        experiences {
          company
          title
          description
          location
          logoUrl
        }
        educations {
          fieldOfStudy
          degreeName
          school
          description
          logoUrl
        }
        certifications {
          url
          name
          licenseNumber
          displaySource
          authority
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const publicAlumniProfiles = /* GraphQL */ `
  query PublicAlumniProfiles(
    $publicProfile: SparseIndexTrue
    $firstName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    publicAlumniProfiles(
      publicProfile: $publicProfile
      firstName: $firstName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        occupation
        headline
        experiences {
          company
          title
          description
          location
          logoUrl
        }
        educations {
          fieldOfStudy
          degreeName
          school
          description
          logoUrl
        }
        certifications {
          url
          name
          licenseNumber
          displaySource
          authority
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const alumniProfilesByCohort = /* GraphQL */ `
  query AlumniProfilesByCohort(
    $cohortID: ID
    $firstName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alumniProfilesByCohort(
      cohortID: $cohortID
      firstName: $firstName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        occupation
        headline
        experiences {
          company
          title
          description
          location
          logoUrl
        }
        educations {
          fieldOfStudy
          degreeName
          school
          description
          logoUrl
        }
        certifications {
          url
          name
          licenseNumber
          displaySource
          authority
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCohort = /* GraphQL */ `
  query GetCohort($id: ID!) {
    getCohort(id: $id) {
      id
      name
      year
      alumni {
        items {
          id
          firstName
          firstNameDisplay
          lastName
          lastNameDisplay
          about
          isOpenToWork
          isWillingToTravel
          publicProfile
          skills
          owner
          linkedInUrl
          countryCode
          stateCode
          cityName
          branch
          cohortID
          email
          isMilitarySpouse
          profilePictureKey
          occupation
          headline
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCohorts = /* GraphQL */ `
  query ListCohorts(
    $filter: ModelCohortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCohorts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        year
        alumni {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
